import { combineReducers } from '@reduxjs/toolkit';

import { accessoryParts } from './accessoryParts';
import { brakesParts } from './brakesParts';
import { carbodyParts } from './carbodyParts';
import { electricParts } from './electricParts';
import { engineParts } from './engineParts';
import { equipmentParts } from './equipmentParts';
import { gasEquipmentParts } from './gasEquipmentParts';
import { heatingParts } from './heatingParts';
import { interiorParts } from './interiorParts';
import { maintenanceParts } from './maintenanceParts';
import { nameParts } from './nameParts';
import { stateParts } from './stateParts';
import { suspensionParts } from './suspensionParts';
import { transmissionParts } from './transmissionParts';
import { typeParts } from './typeParts';
import { tyreSeasonParts } from './tyreSeasonParts';
import { wheelsBoltsParts } from './wheelsBoltsParts';
import { wheelsParts } from './wheelsParts';
import { wheelsRadiusParts } from './wheelsRadiusParts';
import { wheelsWidthParts } from './wheelsWidthParts';

export default combineReducers({
    accessoryParts,
    maintenanceParts,
    brakesParts,
    carbodyParts,
    heatingParts,
    electricParts,
    engineParts,
    equipmentParts,
    gasEquipmentParts,
    interiorParts,
    suspensionParts,
    transmissionParts,
    wheelsParts,
    wheelsRadiusParts,
    wheelsWidthParts,
    wheelsBoltsParts,
    typeParts,
    tyreSeasonParts,
    stateParts,
    nameParts,
});
